import { bindToggleRemote } from '../../smartpak/toggleremote.js';
import { onDOMContentLoaded } from '../../dom/events.js';
import searchPage from './searchpage.js';

onDOMContentLoaded(function () {
    searchPage.init();
    bindToggleRemote();
});

